import React from 'react';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    text: "I've never felt so comfortable at a dentist. The pricing was upfront and there were zero surprises. Highly recommend!",
    author: 'Sarah M.',
    rating: 5
  }, {
    text: 'The staff is incredibly kind. They helped me verify my Medicaid coverage instantly. The treatment was painless and professional.',
    author: 'James R.',
    rating: 5
  }, {
    text: "Best financing options I've found. I was able to get my veneers with a monthly plan that actually fits my budget.",
    author: 'Elena G.',
    rating: 5
  }];
  return <section id="patient-reviews" className="py-20 bg-[#0F2C59] text-white overflow-hidden" data-id="element-178">
      <div className="max-w-7xl mx-auto px-4" data-id="element-179">
        <div className="flex flex-col md:flex-row items-center justify-between mb-16 gap-8" data-id="element-180">
          <div className="flex items-center gap-6 bg-white/10 p-6 rounded-[12px] border border-white/20" data-id="element-181">
            <div className="text-center" data-id="element-182">
              <div className="text-4xl font-bold mb-1" data-id="element-183">5.0</div>
              <div className="flex text-yellow-400" data-id="element-184">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-185" />)}
              </div>
            </div>
            <div className="h-12 w-px bg-white/20" data-id="element-186" />
            <div data-id="element-187">
              <div className="font-bold text-lg" data-id="element-188">Google Review Badge</div>
              <div className="text-sm text-white/70" data-id="element-189">
                Based on 1,500+ verified reviews
              </div>
            </div>
          </div>

          <h2 className="text-3xl font-bold text-right max-w-md" data-id="element-190">
            WHAT OUR PATIENTS ARE SAYING
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-191">
          {reviews.map((review, idx) => <div key={idx} className="bg-white/5 p-8 rounded-[12px] border border-white/10 relative" data-id="element-192">
              <Quote className="absolute top-6 right-8 text-white/10" size={40} data-id="element-193" />
              <div className="flex text-yellow-400 mb-4" data-id="element-194">
                {[...Array(review.rating)].map((_, i) => <Star key={i} size={14} fill="currentColor" data-id="element-195" />)}
              </div>
              <p className="text-lg mb-6 italic leading-relaxed text-white/90" data-id="element-196">
                "{review.text}"
              </p>
              <p className="font-bold text-[#4F709C]" data-id="element-197">— {review.author}</p>
            </div>)}
        </div>
      </div>
    </section>;
}